export default __webpack_public_path__ + "static/media/004-icone-plantio.c6c64f15.png";